import { PropsWithChildren, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useQueryParams } from 'hooks/useQueryParams'

export const RelayRedirect: React.FC<PropsWithChildren<{}>> = ({
  children
}) => {
  const history = useHistory()
  const queryParams = useQueryParams()
  useEffect(() => {
    const relay = queryParams.get('relay')
    if (relay) {
      queryParams.delete('relay')
      history.replace({
        pathname: relay,
        search: queryParams.toString()
      })
    }
  }, [history, queryParams])

  return <>{children}</>
}
